enum NOTIFICATION_TYPE {
  ALL = 'ALL',
  LDEQ = 'LDEQ',
  TCEQ = 'TCEQ',
  // NONE = 'NONE'
}

export default NOTIFICATION_TYPE;
